import Ajv from 'ajv'
import addFormats from 'ajv-formats'
import huamnizeErrors from 'ajv-errors'
import betterAjvErrors from 'better-ajv-errors'

const ajv = new Ajv({
  allErrors: true,
})

addFormats(ajv)
huamnizeErrors(ajv)

ajv.addFormat('uuid', /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/)
ajv.addFormat('phone', /^\+?[ 0-9-()]{3,20}$/)


export function compileSchema(schema){
  const validate = ajv.compile(schema)
  return function validateSchema(data){
    const valid = validate(data)
    validateSchema.errors = validate.errors
    if (!valid) {
      console.error('SCHEMA VALIDATION ERROR')
      console.error('data', data)
      console.error('schema', schema)
      console.error('errors', validate.errors)
      console.error(betterAjvErrors(schema, data, validate.errors))
    }
    return valid
  }
}
